import persistReducer from "redux-persist/es/persistReducer";
import storage from "redux-persist/lib/storage";


/* Persistence utility */
export const persist = (persistConfig, reducer) => persistReducer({ ...persistConfig, storage }, reducer);
